import Typography from "components/styled/Typography"
import { useContext } from "react"
import LazyLoad from "react-lazyload"
import { useT } from "react-polyglot-hooks"
import { CarContext } from "scenes/CarScene/CarContext"
import YoutubeVideo from "components/YoutubeVideo"
import { sendEvent } from "scripts/GoogleAnalytics"

function Video() {
  const t = useT()
  const {
    page,
    car: { brand, model, youtubeId }
  } = useContext(CarContext)

  if (!youtubeId) return null

  const handlePlayVideo = () => {
    sendEvent("Video", { event_category: page, event_label: "play video section" })
  }

  return (
    <div css="margin: 50px 0">
      <Typography variant="title3" el="h2" weight="medium">
        {t("car_data.video.title", { brand, model })}
      </Typography>
      <LazyLoad css={{ height: 0, paddingBottom: `${(9 / 16) * 100}%` }}>
        <YoutubeVideo youtubeId={youtubeId} onPlay={handlePlayVideo} css="padding: 0" />
      </LazyLoad>
    </div>
  )
}

export default Video
